<template>
  <v-app>
    <v-container fluid>
    <SideBarMenu v-if="$route.meta.sidebar"/>
    <v-main>
      <router-view />
    </v-main>
  </v-container>
  </v-app>
</template>

<script>
//import HelloWorld from './components/HelloWorld';
//import ProductView from './components/Product.vue';
import SideBarMenu from './components/Sidebar.vue';

export default {
  name: 'App',

  components: {
    //HelloWorld,
    SideBarMenu,
    //ProductView
  },

  data: () => ({
    showSidebar: true
  }),
  mounted() {
    this.showSidebar =  this.$route.meta.sidebar!==false; 
  },
  computed: {
    
  }
};
</script>
